import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ProfessionalCard } from "../../components/Cards/ProfessionalCard";
import Footer from "../../components/Elements/Footer";
import { Header } from "../../components/Elements/Header";
import ListFilters from "../../components/Elements/ListFilters";
import { ListNav } from "../../components/Elements/ListNav";
import { LoadingScreen } from "../../components/Elements/LoadingScreen";
import { NoDoctors } from "../../components/Elements/NoDoctors";
import { ProfessionalCardSkeleton } from "../../components/Skeletons/ProfessionalCardSkeleton";
import { useDoctorsData } from "../../providers/doctorsData";
import { defaultFilters, useFilters } from "../../providers/filters";
import { usePartnerData } from "../../providers/partnerData";
import { useScheduleInfos } from "../../providers/schedule";

import { MainSpecs } from "../../components/Elements/MainSpecs";
import PageHeader from "../../components/Elements/PageHeader";
import { LocalModal } from "../../components/Modals/LocalModal";
import { hasSecurityIssues } from "../../utils/hasSecurityIssues";
import { useLocationData } from "../../providers/geolocation";
import { MapContainer } from "../../components/Elements/MapContainer";
import { useDocumentTitle } from "../../providers";
const HomePage = () => {
  const { partnerData } = usePartnerData();
  const { getDoctorsWithFilter, getData, doctors, searching } = useDoctorsData();

  const { filters, setFilters, handleGetStates, localModal, setLocalModal, scrollToList } = useFilters();

  const { clearScheduleInfos } = useScheduleInfos();
  const { mapBig } = useLocationData();

  const [searchParams] = useSearchParams();
  const [showMobileMap, setShowMobileMap] = useState(false);

  useDocumentTitle(partnerData?.nome);

  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // cria uma cópia do defaultFilters como ponto de partida
    const filteredParams = { ...defaultFilters };

    const hasParams = Object.keys(defaultFilters).some(key => searchParams.has(key));

    // percorre todas as chaves que existem no defaultFilters para validar a segurança
    Object.keys(defaultFilters).forEach((key) => {
      const value = searchParams.get(key);

      if (value && !hasSecurityIssues(value)) {
        if (key === "page") {
          filteredParams.page = value ? Number(value) : null;
        } else {
          (filteredParams as any)[key] = value;
        }
      }
    });

    // sobrescreve idPartner vindo do partnerData
    filteredParams.idPartner = partnerData?.idEmpresa || null;
    setFilters(filteredParams);
    if (hasParams && filteredParams.page != searchParams.get("page")) {
      scrollToList.current = true
    }
  }, [searchParams, partnerData]);

  useEffect(() => {
    handleGetStates();
    clearScheduleInfos();
    if (searchParams.toString() !== "") {
      getData();
    }
  }, [partnerData]);

  useEffect(() => {
    if (scrollToList.current) {
      listRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    getDoctorsWithFilter(filters);
  }, [filters, scrollToList]);

  useEffect(() => {
    return () => {
      scrollToList.current = false;
    }
  }, []);

  return (
    <>
      {localModal && (
        <LocalModal defaultState="PR" defaultCity="Curitiba" modal={localModal} closeModal={() => setLocalModal(false)} />
      )}

      <Header />

      <div id="wrapper">
        <div className="content">
          <PageHeader />
          <MainSpecs />

          <div ref={listRef} id="listagem" className="pt-4">
            <ListFilters />
            <div className={`listagem ${mapBig && 'map-big'}`}>
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg medicos-container">
                    {searching ? (
                      <>
                        <div className="mb-5">
                          <ProfessionalCardSkeleton />
                        </div>
                        <div className="mb-5">
                          <ProfessionalCardSkeleton />
                        </div>
                      </>
                    ) : (
                      <>
                        {doctors.length > 0 ? (
                          <>
                            {doctors.map((elm, i) => (
                              <ProfessionalCard key={elm.id} {...elm} />
                            ))}
                          </>
                        ) : (
                          <NoDoctors />
                        )}
                      </>
                    )}
                  </div>
                  <div className="d-none d-lg-block col-lg-4 mapa-container">
                    <MapContainer />
                  </div>
                </div>
              </div>
              {doctors.length > 0 && <ListNav />}
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary map-fab d-lg-none shadow"
        onClick={() => setShowMobileMap(true)}
        aria-label="Ver locais de atendimento no mapa"
      >
        <i className="las la-map-marked-alt me-2" aria-hidden="true"></i>
        Mapa
      </button>

      {showMobileMap && (
        <div
          className="map-overlay d-lg-none"
          role="dialog"
          aria-modal="true"
          aria-label="Mapa dos locais de atendimento"
        >
          <MapContainer variant="overlay" onClose={() => setShowMobileMap(false)} />
        </div>
      )}

      <Footer />

    </>
  );
};

export default HomePage;
